module.exports = __webpack_public_path__ + "static/media/lucien-s.8d2cb5d8.png";